/*  Shared  */
import { SessionHelper } from 'application/Shared/Helpers';
import {
    PartnerTenantLinks,
    PartnerTenantLinksTargetTenantClients
} from 'application/Shared/types/partnerTenantLinks';
import { Session } from 'application/Shared/types/session';

/**
 * Gets the client name from the session based on the provided client ID
 * @param clientId - The ID of the client to look up
 * @param session - The current session object containing partner tenant links
 * @returns The client name if found, null otherwise
 */
export const getClientName = ({
    clientId,
    session
}: {
    clientId: string | undefined;
    session: Session;
}) => {
    const sessionHelper = new SessionHelper(session);
    const partnerTenantLinks = sessionHelper.getPartnerTenantLinks();

    if (!clientId || !partnerTenantLinks.length) return null;

    // If it is the same as the top level partnerTenantLinks, then it is the partner tenant
    if (partnerTenantLinks[0]?.platformTenantId === clientId) {
        return partnerTenantLinks[0]?.targetTenant.name;
    }

    // Find the client name by searching through all targetTenantClients
    const findClientName = (clientId: string) => {
        const client = partnerTenantLinks
            .flatMap(
                (link: PartnerTenantLinks) => link.targetTenantClients || []
            )
            .find(
                (client: PartnerTenantLinksTargetTenantClients) =>
                    client.id === clientId
            );
        return client?.name || null;
    };

    const clientName = findClientName(clientId);
    return clientName;
};
